export const hasWhitespace = (value) => /\s/.test(value);
export const isValidCssId = (value) => /^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$/.test(value);
export const toUpperCase = (str) => str.toUpperCase();
// Trim the value, considering <br> tags and line breaks as whitespace.
// \s already covers \r, \n and \r\n; listing them as separate alternatives made
// every whitespace run matchable in exponentially many ways, so a long run of
// newlines that failed the trailing-anchor branch froze the tab (ReDoS).
export const htmlTrim = (value) => {
    const trimRegex = /^(?:<br\s*\/?>|\s)+|(?:<br\s*\/?>|\s)+$/g;
    return value.replace(trimRegex, '');
};
export const parseBoolean = (value) => {
    const normalizedValue = (value !== null && value !== void 0 ? value : 'n').toString().trim().toLowerCase();
    return ['true', 't', '1', 'yes', 'y'].includes(normalizedValue);
};
